import selectProductsProps from "./SelectProductToCancel/formProps";
import selectReasonProps from "./CancelationReason/formProps";
import loyaltyLevelProps from "./LoyaltyLevelStep/formProps";
import claimsBenefitsProps from "./ClaimsBenefits/formProps";
import ratingCluppServiceProps from "./RatingCluppService/formProps";
import ratingReferalProps from "./RatingReferal/formProps";
import benefitsCluppProps from "./BenefitsClupp/formProps";
import describeCluppProps from "./DescribeClupp/formProps";
import toDoBetterProps from "./ToDoBetter/formProps";
import cancelationConfirmationProps from "./CancelationConfirmation/formProps";
import cluppReviewProps from "./CluppReview/formProps";
import finalProps from "./Final/formProps";
import keepInsuranceProps from "./KeepInsurance/formProps";
import otherInsuranceQuestionsProps from "./OtherInsuranceQuestions/formProps";
import dontLikeCluppProps from "./DontLikeClupp/formProps";
import trustInCluppProps from "./TrustInClupp/formProps";
import procedureQuestionProps from "./ProcedureQuestion/formProps";
import offerDiscountProps from "./OfferDiscount/formProps";
import aceptDiscountProps from "./AceptDiscount/formProps";
import cluppValuationProps from "./CluppValuation/formProps";
import referedProgramProps from "./ReferedProgram/formProps";
import odometerPhotoExplanationProps from "./OdometerPhotoExplanation/formProps";
import errorDiscountProps from "./ErrorDiscount/formProps";
import aceptPauseProps from "./AceptPause/formProps";
import changePeriodProps from "./ChangePeriod/formProps";
import upsellProps from "./Upsell/formProps";
import errorPauseProps from "./ErrorPause/formProps";
import otherInsuranceQuotationProps from "./OtherInsuranceQuotation/formProps";
import offerPauseInsuranceProps from "./OfferPauseInsurance/formProps";
import newFeeInformationProps from "./NewFeeInformation/formProps";

const setCancelationForm = ({ pageId, uid, navigate }) => {
  const formProps = {
    producto: selectProductsProps,
    razon: selectReasonProps,
    lealtad: loyaltyLevelProps,
    beneficios: benefitsCluppProps,
    siniestros: claimsBenefitsProps,
    servicio: ratingCluppServiceProps,
    referidos: ratingReferalProps,
    "refiere-gana": referedProgramProps,
    reseña: cluppReviewProps,
    "describe-clupp": describeCluppProps,
    mejoras: toDoBetterProps,
    confirmacion: cancelationConfirmationProps,
    final: finalProps,
    mantener: keepInsuranceProps,
    "otro-seguro": otherInsuranceQuestionsProps,
    "no-gusto": dontLikeCluppProps,
    "otro-seguro-cotizacion": otherInsuranceQuotationProps,
    confianza: trustInCluppProps,
    tramite: procedureQuestionProps,
    descuento: offerDiscountProps,
    "aceptar-descuento": aceptDiscountProps,
    valuacion: cluppValuationProps,
    odometro: odometerPhotoExplanationProps,
    error: errorDiscountProps,
    "error-pausar": errorPauseProps,
    pausar: offerPauseInsuranceProps,
    "aceptar-pausa": aceptPauseProps,
    "cambiar-periodicidad": changePeriodProps,
    tarifa: newFeeInformationProps,
    upsell: upsellProps,
  };

  const fromPropsToSet = formProps[pageId];
  if (!formProps || !formProps[pageId]) {
    navigate(`/formulario/cancelacion/producto?uid=${uid}`);
  }

  return {
    ...fromPropsToSet,
    onLoad: async (props) => fromPropsToSet.onLoad({ ...props, uid }),
    onSubmit: async (props) => fromPropsToSet.onSubmit({ ...props }),
    content: (props) => fromPropsToSet.content({ ...props }),
    nextPage: (props) => fromPropsToSet.nextPage({ ...props, uid }),
    prevPage: (props) => fromPropsToSet.prevPage({ ...props, uid }),
  };
};

export default setCancelationForm;
